import get from 'lodash/get';
import SentryUtils from '@spothero/utils/sentry';

const ErrorUtils = {
    formatError(error) {
        return (
            error &&
            (error.message ||
                error.statusText ||
                get(error, 'response.data', ''))
        );
    },
    sendSentryError(error) {
        const errorMessage = this.formatError(error);

        SentryUtils.addData({
            caughtError: error,
        });
        SentryUtils.sendMessage({
            message: errorMessage,
            level: 'error',
        });
    },
};

export default ErrorUtils;
